import { render, staticRenderFns } from "./ChoosePage.vue?vue&type=template&id=03cd1ab9&scoped=true&"
import script from "./ChoosePage.vue?vue&type=script&lang=js&"
export * from "./ChoosePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd1ab9",
  null
  
)

export default component.exports